import styled from 'styled-components';

export const Message = styled.label`
  margin-bottom: 0.5em;
  color: palevioletred;
  display: block;
  font-size: ${({ theme }) => theme.fontSize.xxs};
  color: ${({ theme }) => theme.primary};
  font-weight: ${({ theme }) => theme.bold};
  max-width: 400px;
`;

export default Message;
